
import { mapActions, mapGetters } from 'vuex';
// eslint-disable-next-line import/extensions
import pdf from 'pdfvuer';

export default {
  name: 'InfoAfterEvent',
  components: {
    pdf,
  },
  data() {
    return {
      component: 'statistics',
      images: [],
      galleryWithDetails: [],
      imgIndex: null,
      options: {
        title: false,
        scalable: false,
        rotatable: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      event: 'events/fetchEvent',
    }),
  },
  async mounted() {
    if (this.$route.params.eventId) {
      const data = await this.getImages({ event: this.$route.params.eventId });
      this.galleryWithDetails = data.results;
      this.images = data.results.map(({ image }) => image);
    }
  },
  methods: {
    ...mapActions({
      getImages: 'mediaArchive/getImages',
    }),
    closeGallery() {
      this.imgIndex = null;
    },
    getHostName(url) {
      let videoType = 'vimeo';
      const regex = new RegExp(
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?.*/,
      );
      if (regex.test(url)) {
        videoType = 'youtube';
      }
      return videoType;
    },
    eventName(name) {
      return name.split(' ').join('_');
    },
  },
};
